import {Controller} from "@hotwired/stimulus"
import {formValidation, plugins} from "../../../../vendor/javascript/@form-validation/esm/bundle/popular"
import * as Bootstrap5 from "../../../../vendor/javascript/@form-validation/esm/plugin-bootstrap5/index.js"

// Connects to data-controller="validators--checkout-shipping"
export default class extends Controller {
    connect() {
        console.log('CheckoutShippingController connected');
        this.initializeValidation();

        // Listen for state field changes from the country-state controller
        this.element.addEventListener('country-state:fieldChanged', this.handleStateFieldChanged.bind(this));
    }

    initializeValidation() {
        const form = document.getElementById('frm-checkout-shipping');
        if (!form) {
            console.error('Checkout shipping form element not found');
            return;
        }

        // Initialize form validation
        this.validation = formValidation(form, {
            fields: {
                'order[ship_firstname]': {
                    validators: {
                        notEmpty: {
                            message: 'The first name is required'
                        }
                    }
                },
                'order[ship_lastname]': {
                    validators: {
                        notEmpty: {
                            message: 'The last name is required'
                        }
                    }
                },
                'order[ship_dayphone]': {
                    validators: {
                        notEmpty: {
                            message: 'The telephone number is required.'
                        }
                    }
                },
                'order[ship_address1]': {
                    validators: {
                        notEmpty: {
                            message: 'The street address is required.'
                        }
                    }
                },
                'order[ship_city]': {
                    validators: {
                        notEmpty: {
                            message: 'The city is required.'
                        }
                    }
                },
                'order[ship_state]': {
                    validators: {
                        notEmpty: {
                            message: 'The State is required.'
                        }
                    }
                },
                'order[ship_zipcode]': {
                    validators: {
                        notEmpty: {
                            message: 'The zip code is required.'
                        }
                    }
                },
                'order[email]': {
                    validators: {
                        notEmpty: {
                            message: 'The email address is required'
                        },
                        emailAddress: {
                            message: 'The input is not a valid email address'
                        }
                    }
                }
            },
            plugins: {
                trigger: new plugins.Trigger({
                    event: 'blur'
                }),
                submitButton: new plugins.SubmitButton(),
                bootstrap5: new Bootstrap5.Bootstrap5({
                    rowSelector: '.fv-row',
                    eleInvalidClass: 'is-invalid',
                    eleValidClass: 'is-valid'
                })
            }
        })
            .on('core.form.valid', function (e) {
                // Form is valid, submit it
                console.log('Form is VALID - submitting');
                form.submit();
            })
            .on('core.form.invalid', function (e) {
                // Form is invalid, prevent submission
                console.log('Form is INVALID - preventing submission');
            });

        // Store the FormValidation instance on the form element
        // This allows the country-state controller to access it if needed
        form._formValidation = this.validation;
    }

    /**
     * Handle state field changes from the country-state controller
     * This revalidates the state field when it's dynamically changed
     */
    handleStateFieldChanged(event) {
        if (!this.validation) return;

        const fieldName = 'order[ship_state]';

        // Reapply validation to the state field after a short delay
        // to ensure the DOM has been updated
        setTimeout(() => {
            try {
                this.validation.removeField(fieldName);
            } catch (e) {
                console.warn('Field was not yet registered for validation', e);
            }

            this.validation.addField(fieldName, {
                validators: {
                    notEmpty: {
                        message: 'The State is required.'
                    }
                }
            });
        }, 100);
    }

    disconnect() {
        if (this.validation) {
            this.validation.destroy();
        }

        this.element.removeEventListener('country-state:fieldChanged', this.handleStateFieldChanged);
    }
}
